import { useField, FieldProps } from 'formik'
import { Logo, Button } from './PaymentMethodField.style'

interface PaymentMethodFieldProps extends FieldProps {
  value: string
  label?: string
  imageUrl: string
}

const PaymentMethodField = ({
  value,
  label,
  imageUrl,
  field: { onChange, value: fieldValue, ...field },
  form,
  ...props
}: PaymentMethodFieldProps) => {
  const [, , helpers] = useField(field?.name)
  const isValueSet = !!(typeof fieldValue === 'string' && fieldValue)

  const onClick = () => helpers.setValue(value)

  return (
    <Button
      fullWidth={false}
      variant="outlined"
      {...props}
      active={isValueSet && value === fieldValue}
      onClick={onClick}
    >
      <Logo src={imageUrl} />
    </Button>
  )
}

export default PaymentMethodField
